export default __webpack_public_path__ + "static/media/heart-rate.9ff65a77.svg";